import { HNDialogMicrowebFastlegepanel } from '../types/Resources';

import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { getModifiedResourcesForTest } from '@helsenorge/framework-utils/resources';

import defaultResources from './HN.Dialog.Microweb.Fastlegepanel.nb-NO.json';
import { HNDialogMicrowebFastlegepanelProject } from '../constants/project-name';

type ResourceItem = { [key: string]: string } | Record<string, string>;

export const getResources = async <T extends ResourceItem>(
  projectName: string,
  language: LanguageLocales = LanguageLocales.NORWEGIAN
): Promise<T> => {
  if (projectName === HNDialogMicrowebFastlegepanelProject && language === LanguageLocales.NORWEGIAN) {
    return defaultResources as unknown as T;
  }
  try {
    const resources: { default: T } = await import(`./${projectName}.${language}.json`);

    return resources.default;
  } catch (error) {
    throw new Error(`Failed to load resources for ${projectName} in ${language}: ${error}`);
  }
};

export const getResourcesTestHelper = (): HNDialogMicrowebFastlegepanel => {
  return getModifiedResourcesForTest(defaultResources) as HNDialogMicrowebFastlegepanel;
};
